export const SelectChargeTypeOpt = [
    { id: 2, name: "Per Unit" },
    { id: 1, name: "Per Kg" },
    // { id: 3, name: "Per KG - KM" },
    { id: 4, name: "Percentage Of Freight" }
]
export const selectChargeOpt = [
    { id: 1, name: "Pickup Charge" },
    { id: 2, name: "Drop Off Charge" },
]